export const AVIATION_ENGINE_LOCATIONS = [
  {
    identifier: "DataPlate",
    name: "DataPlate",
    abbreviation: "DataPlate",
    description: "",
    inspectionFor: [],
    isDataPlate: true,
    rectInStructImage: {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    children: []
  },
  {
    identifier: "INLET",
    name: "INLET",
    abbreviation: "INLET",
    description: "",
    inspectionFor: ["Blades"],
    isDataPlate: false,
    rectInStructImage: {
      top: 13,
      left: 33,
      width: 4,
      height: 63
    },
    children: []
  },
  {
    identifier: "LPC",
    name: "Low Pressure Compressor",
    abbreviation: "LPC",
    description: "",
    inspectionFor: ["Blades"],
    isDataPlate: false,
    rectInStructImage: {
      top: 30,
      left: 37,
      width: 5,
      height: 30
    },
    children: [
      {
        identifier: "LPC_S01_LE",
        name: "Stage 01 Leading Edge",
        abbreviation: "S01_LE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "02_LPC_S01_LE"
      },
      {
        identifier: "LPC_S01_TE",
        name: "Stage 01 Trailing Edge",
        abbreviation: "S01_TE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "03_LPC_S01_TE"
      },
      {
        identifier: "LPC_S02_LE",
        name: "Stage 02 Leading Edge",
        abbreviation: "S02_LE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "04_LPC_S02_LE"
      },
      {
        identifier: "LPC_S02_TE",
        name: "Stage 02 Trailing Edge",
        abbreviation: "S02_TE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "05_LPC_S02_TE"
      },
      {
        identifier: "LPC_S03_LE",
        name: "Stage 03 Leading Edge",
        abbreviation: "S03_LE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "06_LPC_S03_LE"
      },
      {
        identifier: "LPC_S03_TE",
        name: "Stage 03 Trailing Edge",
        abbreviation: "S03_TE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "07_LPC_S03_TE"
      },
      {
        identifier: "LPC_S04_LE",
        name: "Stage 04 Leading Edge",
        abbreviation: "S04_LE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "08_LPC_S04_LE"
      },
      {
        identifier: "LPC_S04_TE",
        name: "Stage 04 Trailing Edge",
        abbreviation: "S04_TE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "09_LPC_S04_TE"
      },
      {
        identifier: "LPC_S05_LE",
        name: "Stage 05 Leading Edge",
        abbreviation: "S05_LE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "10_LPC_S05_LE"
      },
      {
        identifier: "LPC_S05_TE",
        name: "Stage 05 Trailing Edge",
        abbreviation: "S05_TE",
        description: "",
        inspectionFor: ["90"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "11_LPC_S05_TE"
      }
    ]
  },
  {
    identifier: "HPC",
    name: "High Pressure Compressor",
    abbreviation: "HPC",
    description: "",
    inspectionFor: ["Blades"],
    isDataPlate: false,
    rectInStructImage: {
      top: 30,
      left: 44,
      width: 10,
      height: 30
    },
    children: [
      {
        identifier: "HPC_S01_LE",
        name: "Stage 01 Leading Edge",
        abbreviation: "S01_LE",
        description: "",
        inspectionFor: ["80"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "12_HPC_S01_LE"
      },
      {
        identifier: "HPC_S01_TE",
        name: "Stage 01 Trailing Edge",
        abbreviation: "S01_TE",
        description: "",
        inspectionFor: ["80"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "13_HPC_S01_TE"
      },
      {
        identifier: "HPC_S02_LE",
        name: "Stage 02 Leading Edge",
        abbreviation: "S02_LE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "14_HPC_S02_LE"
      },
      {
        identifier: "HPC_S02_TE",
        name: "Stage 02 Trailing Edge",
        abbreviation: "S02_TE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "15_HPC_S02_TE"
      },
      {
        identifier: "HPC_S03_LE",
        name: "Stage 03 Leading Edge",
        abbreviation: "S03_LE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "16_HPC_S03_LE"
      },
      {
        identifier: "HPC_S03_TE",
        name: "Stage 03 Trailing Edge",
        abbreviation: "S03_TE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "17_HPC_S03_TE"
      },
      {
        identifier: "HPC_S04_LE",
        name: "Stage 04 Leading Edge",
        abbreviation: "S04_LE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "18_HPC_S04_LE"
      },
      {
        identifier: "HPC_S04_TE",
        name: "Stage 04 Trailing Edge",
        abbreviation: "S04_TE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "19_HPC_S04_TE"
      },
      {
        identifier: "HPC_S05_LE",
        name: "Stage 05 Leading Edge",
        abbreviation: "S05_LE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "20_HPC_S05_LE"
      },
      {
        identifier: "HPC_S05_TE",
        name: "Stage 05 Trailing Edge",
        abbreviation: "S05_TE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "21_HPC_S05_TE"
      },
      {
        identifier: "HPC_S06_LE",
        name: "Stage 06 Leading Edge",
        abbreviation: "S06_LE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "22_HPC_S06_LE"
      },
      {
        identifier: "HPC_S06_TE",
        name: "Stage 06 Trailing Edge",
        abbreviation: "S06_TE",
        description: "",
        inspectionFor: ["70"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "23_HPC_S06_TE"
      },
      {
        identifier: "HPC_S07_LE",
        name: "Stage 07 Leading Edge",
        abbreviation: "S07_LE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "24_HPC_S07_LE"
      },
      {
        identifier: "HPC_S07_TE",
        name: "Stage 07 Trailing Edge",
        abbreviation: "S07_TE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "25_HPC_S07_TE"
      },
      {
        identifier: "HPC_S08_LE",
        name: "Stage 08 Leading Edge",
        abbreviation: "S08_LE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "26_HPC_S08_LE"
      },
      {
        identifier: "HPC_S08_TE",
        name: "Stage 08 Trailing Edge",
        abbreviation: "S08_TE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "27_HPC_S08_TE"
      },
      {
        identifier: "HPC_S09_LE",
        name: "Stage 09 Leading Edge",
        abbreviation: "S09_LE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "28_HPC_S09_LE"
      },
      {
        identifier: "HPC_S09_TE",
        name: "Stage 09 Trailing Edge",
        abbreviation: "S09_TE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "29_HPC_S09_TE"
      },
      {
        identifier: "HPC_S10_LE",
        name: "Stage 10 Leading Edge",
        abbreviation: "S10_LE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "30_HPC_S10_LE"
      },
      {
        identifier: "HPC_S10_TE",
        name: "Stage 10 Trailing Edge",
        abbreviation: "S10_TE",
        description: "",
        inspectionFor: ["60"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "31_HPC_S10_TE"
      }
    ]
  },
  {
    identifier: "CC",
    name: "Combustion Chamber",
    abbreviation: "CC",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 30,
      left: 53,
      width: 6,
      height: 30
    },
    children: []
  },
  {
    identifier: "HPT",
    name: "High Pressure Turbine",
    abbreviation: "HPT",
    description: "",
    inspectionFor: ["Blades"],
    isDataPlate: false,
    rectInStructImage: {
      top: 30,
      left: 59,
      width: 3,
      height: 30
    },
    children: [
      {
        identifier: "HPT_NGV",
        name: "Nozzle Guide Vane",
        abbreviation: "NGV",
        description: "",
        inspectionFor: ["50"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "33_HPT_NGV"
      },
      {
        identifier: "HPT_S01_LE",
        name: "Stage 01 Leading Edge",
        abbreviation: "S01_LE",
        description: "",
        inspectionFor: ["50"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "34_HPT_S01_LE"
      },
      {
        identifier: "HPT_S01_TE",
        name: "Stage 01 Trailing Edge",
        abbreviation: "S01_TE",
        description: "",
        inspectionFor: ["50"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "35_HPT_S01_TE"
      },
      {
        identifier: "HPT_S02_LE",
        name: "Stage 02 Leading Edge",
        abbreviation: "S02_LE",
        description: "",
        inspectionFor: ["50"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "36_HPT_S02_LE"
      },
      {
        identifier: "HPT_S02_TE",
        name: "Stage 02 Trailing Edge",
        abbreviation: "S02_TE",
        description: "",
        inspectionFor: ["50"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "37_HPT_S02_TE"
      },
      {
        identifier: "HPT_Shroud",
        name: "Shroud",
        abbreviation: "Shroud",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "38_HPT_Shroud"
      }
    ]
  },
  {
    identifier: "LPT",
    name: "Low Pressure Turbine",
    abbreviation: "LPT",
    description: "",
    inspectionFor: ["Blades"],
    isDataPlate: false,
    rectInStructImage: {
      top: 30,
      left: 63,
      width: 2,
      height: 30
    },
    children: [
      {
        identifier: "LPT_S01_LE",
        name: "Stage 01 Leading Edge",
        abbreviation: "S01_LE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "39_LPT_S01_LE"
      },
      {
        identifier: "LPT_S01_TE",
        name: "Stage 01 Trailing Edge",
        abbreviation: "S01_TE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "40_LPT_S01_TE"
      },
      {
        identifier: "LPT_S02_LE",
        name: "Stage 02 Leading Edge",
        abbreviation: "S02_LE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "41_LPT_S02_LE"
      },
      {
        identifier: "LPT_S02_TE",
        name: "Stage 02 Trailing Edge",
        abbreviation: "S02_TE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "42_LPT_S02_TE"
      },
      {
        identifier: "LPT_S03_LE",
        name: "Stage 03 Leading Edge",
        abbreviation: "S03_LE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "43_LPT_S03_LE"
      },
      {
        identifier: "LPT_S03_TE",
        name: "Stage 03 Trailing Edge",
        abbreviation: "S03_TE",
        description: "",
        inspectionFor: ["40"],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "44_LPT_S03_TE"
      }
    ]
  }
];
